// extracted by mini-css-extract-plugin
export default {"container":"App_container__4L7Vo","mobile":"App_mobile__cBbeb","intro-gradient":"App_intro-gradient__YZAU4"};